<div class="apply-one-grid apply-one-style">
  @if (contractsByBrand) {
    <div class="site-width">
      <div class="container-fluid pt-1 pt-md-3 pb-2 pb-md-3">
        <a [routerLink]="['/accueil']" class="o-link-arrow mb-2"
          >{{ 'ecm.selector.contract.homepageLinkLabel' | translate }}</a
          >
          <h1>{{ 'ecm.selector.contract.title' | translate }}</h1>
          <!-- contracts list -->
          @if (contractsByBrand.size > 0) {
            @for (brand of brandsAvailable; track brand; let isFirst = $first; let isLast = $last) {
              <div
                [ngClass]="{'mb-2 mb-md-3': contractsByBrand.size > 1 && !isLast}"
                >
                <!-- other universe title, when multiple brand are available -->
                @if (contractsByBrand.size > 1 && !isFirst) {
                  <h2>
                    {{ 'ecm.selector.universe.' + brand + '.title' | translate }}
                  </h2>
                }
                <ul class="items-list row">
                  @for (contract of contractsByBrand.get(brand); track contract) {
                    <li class="col-12 col-md-6">
                      <ecm-mat-item-list
                        [e2e]="contract.cid"
                [itemIcon]="isFirst
                                        ? ('ecm.selector.contract.' + contract.universe + '.' + getContractActivity(contract) + '.icon' | translate)
                                        : reverseBrandLogoUrl"
                [itemAlt]="''"
                [itemLabel]="'ecm.selector.contract.'
                                        + contract.universe + '.' + getContractActivity(contract) + '.label' | translate: {
                                        offerName: contract.offerName
                                    }"
                        [itemText]="contractDescriptions.get(contract.cid)"
                        [itemPath]="getReturnUrl(contract.cid)"
                        (materialItemListEvent)="redirectToReturnUrl(contract)"
                      ></ecm-mat-item-list>
                    </li>
                  }
                </ul>
              </div>
            }
          } @else {
            <div class="text-mw">
              <ecm-mat-alert
                [style]="'warning'"
                [title]="'ecm.selector.error.unavailable.title' | translate"
              ></ecm-mat-alert>
            </div>
          }
          <!-- no contract available -->
        </div>
      </div>
      <!-- rebound links -->
      @if (!isWebviewContext) {
        <ecm-selector-rebound-links [universe]="universe"></ecm-selector-rebound-links>
      }
    } @else {
      <div class="py-5">
        <ecm-mat-spinner></ecm-mat-spinner>
      </div>
    }
  </div>

  <!-- usage selector -->

  <!-- loader -->
